import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportHistoryCheckAwtgRanPath } from '@api/hitoryCheck';

import { TAwtgRanExportPathDTO } from '@interfaces/cmModule/dto/historyCheckDTO';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { HC_AWTG_RAN_PATH_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportHcAwtgRanPath = () => {
	const dispatch = useAppDispatch();

	const { mutate } = useMutation<TAwtgRanExportPathDTO>({
		mutationKey: [HC_AWTG_RAN_PATH_EXPORT],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: exportHistoryCheckAwtgRanPath,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportConfigurationComparisonSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return { exportPath: mutate };
};
